export default "__VITE_ASSET__mHp8WchN__"